import { render, staticRenderFns } from "./cityForm.vue?vue&type=template&id=67b151f3&scoped=true&"
import script from "./cityForm.vue?vue&type=script&lang=js&"
export * from "./cityForm.vue?vue&type=script&lang=js&"
import style0 from "./cityForm.vue?vue&type=style&index=0&id=67b151f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b151f3",
  null
  
)

export default component.exports